import { Skeleton } from '@savvy-kit/components/skeleton';
import { Landmark } from 'lucide-react';
import { renderItemIcon } from 'src/utils/portfolio-item-display';

import { financialAccountIconColors } from '@savvy/deprecated-shared/theme';

import NetWorthItemDescriptionRow from './views/net-worth-item-description-row';

type PendingProviderAccountRowProps = {
  readonly providerName: string | null;
};

export function PendingProviderAccountRow({ providerName }: PendingProviderAccountRowProps) {
  return (
    <div className="flex items-center justify-between py-4 pl-2">
      <NetWorthItemDescriptionRow
        icon={renderItemIcon(financialAccountIconColors.bankAccount, <Landmark color="#fff" size={20} />)}
        title={providerName || 'New account'}
        subtitle="Importing accounts…"
      />
      <Skeleton className="h-4 w-[76px]" />
    </div>
  );
}
